import { isCateringTeamOrderShareVisit } from '@/components/page-specific/catering/common/helpers/basket-link'

export type MenuViewSource =
  | 'carousel'
  | 'supplier-tile'
  | 'direct'
  | 'draft-order-list'
  | 'edit-order'
  | 'edit-standing-order'
  | 'draft-order-calendar'
  | 'top-picks-calendar'
  | 'item-search'
  | 'team-order'
  | 'unknown'

const VALID_SOURCES = new Set<MenuViewSource>([
  'carousel',
  'supplier-tile',
  'direct',
  'draft-order-list',
  'edit-order',
  'edit-standing-order',
  'draft-order-calendar',
  'top-picks-calendar',
  'item-search',
  'team-order',
  'unknown',
])

export const getMenuViewSourceLabel = (source: MenuViewSource): string => {
  switch (source) {
    case 'carousel':
      return 'Carousel'
    case 'supplier-tile':
      return 'Supplier Tile'
    case 'direct':
      return 'Direct'
    case 'draft-order-list':
      return 'Draft Order (Order list)'
    case 'edit-order':
      return 'Edit Order'
    case 'edit-standing-order':
      return 'Edit Standing Order'
    case 'draft-order-calendar':
      return 'Draft Order (Calendar)'
    case 'top-picks-calendar':
      return 'Top Picks (Calendar)'
    case 'item-search':
      return 'Item Search'
    case 'team-order':
      return 'Team Order'
    case 'unknown':
    default:
      return 'Unknown'
  }
}

export const getMenuViewSource = (searchParams: URLSearchParams | null): MenuViewSource => {
  const defaultSource = isCateringTeamOrderShareVisit(searchParams) ? 'team-order' : 'direct'
  const rawSource = searchParams?.get('source')?.toLowerCase() ?? defaultSource
  if (VALID_SOURCES.has(rawSource as MenuViewSource)) {
    return rawSource as MenuViewSource
  }
  return 'unknown'
}
